import { isEmpty } from 'lodash-es'
import { POS_ORDER_TYPE } from '../static'

/**
 * Ojek-online detail for thermal / plain receipt (matches OrderDetail + API order_type_data.ojol).
 */
export const getOjolDetailForReceipt = (data) => {
  if (!data) {
    return null
  }
  const typeId =
    data.order_type_id ?? data.invoice_type_id ?? data.order_type?.id ?? data.invoice_type?.id
  if (`${typeId ?? ''}` !== `${POS_ORDER_TYPE.ONLINE_MOTORCYCLE_TAXI}`) {
    return null
  }
  const ojol =
    data.order_type_data?.ojol || data.invoice_type_data?.ojol || data.invoice_type_details?.ojol
  return isEmpty(ojol) ? null : ojol
}
